import request from '@/utils/request';
import { GetAssignedProductsResult, GetLockProductsResult } from './types';

/**
 * 获取已分配的货品
 */
export const getAssignedProducts = async (date: string, locationCode: string): Promise<GetAssignedProductsResult> => {
  const { data } = await request({
    url: '/dn/packing/selectlist',
    method: 'get',
    params: { date, location_codes: [locationCode] },
  });

  const convertProduct = (raw: any) => ({
    id: raw.id,
    item_name: raw.item_name,
    item_number: raw.item_number,
    active: raw.active,
    qty: raw.qty,
    actual_quantity: raw.actual_quantity,
    type: raw.type,
  });

  return data.map(convertProduct);
};

/**
 * 获取分配给当前用户的商品
 */
export const getProducts = (date: string, locationCode: string) => request({
  url: '/dn/packing/list',
  method: 'get',
  params: { date, location_codes: [locationCode] },
});

/**
 * 获取已锁定的货品
 */
export const getLockProducts = async (date: string, locationCode: string): Promise<GetLockProductsResult> => {
  const { data } = await request({
    url: '/dn/packing/lock/list',
    method: 'get',
    params: { date, location_codes: [locationCode] },
  });

  const convertProduct = (raw: any) => ({
    id: raw.id,
    item_name: raw.item_name,
    item_number: raw.item_number,
    active: raw.active,
    qty: raw.qty,
    actual_quantity: raw.actual_quantity,
    type: raw.type,
  });

  return data.map(convertProduct);
};

/**
 * 开始分货
 */
export const start = (date: string, locationCode: string, itemNumbers: string[]) => request({
  url: '/dn/packing/start',
  method: 'post',
  data: {
    date,
    location_codes: [locationCode],
    item_numbers: itemNumbers,
  },
});

/**
 * 解除已锁定的货品
 */
export const unlock = (date: string, locationCode: string, itemNumbers: string[]) => request({
  url: '/dn/packing/unlock',
  method: 'post',
  data: {
    date,
    location_codes: [locationCode],
    item_numbers: itemNumbers,
  },
});

export const finish = (ids: string[], beginDatetime: string, endDatetime: string) => request({
  url: '/dn/packing/finish',
  method: 'post',
  data: {
    dn_ids: ids,
    begin_packing: beginDatetime,
    over_packing: endDatetime,
  },
});

export const complet = (ids: string[], beginDatetime: string, endDatetime: string) => request({
  url: '/dn/packing/complet',
  method: 'post',
  data: {
    dn_ids: ids,
    begin_packing: beginDatetime,
    over_packing: endDatetime,
  },
});

export const getAnomalyStocks = (date: string, locationCode: string) => request({
  url: `/anomalyStocks/${date}`,
  method: 'get',
  params: {
    location_codes: [locationCode],
  },
});

export const getAnomalyQuantitys = (date: string, locationCode: string) => request({
  url: `/anomalyQuantitys/${date}`,
  method: 'get',
  params: {
    location_codes: [locationCode],
  },
});

export const updateAnomalyQty = (
  date: string,
  locationCode: string,
  itemNumber: string,
  driverNumber: string,
  qty: string,
  stationNumber: string,
  type: string,
  comment: string,
) => request({
  url: '/anomalyQuantitys',
  method: 'post',
  data: {
    date,
    location_code: locationCode,
    item_number: itemNumber,
    driver_number: driverNumber,
    quantity: qty,
    station_number: stationNumber,
    type,
    comment,
  },
});

export const deleteAnomalyQty = (id: string) => request({
  url: `/anomalyQuantitys/${id}`,
  method: 'delete',
});
